import React from 'react';
import holocost from '../../Image/holocost.png';
import idf from '../../Image/idf.png';
import terror from '../../Image/terror.png';
import underground from '../../Image/underground.png';
import martyrs from '../../Image/martyrs.png';

const DEATH_CAUSES = {
    'נהרג בפעולת איבה': {
        image: terror,
        textM: 'נהרג בפעולת איבה',
        textF: 'נהרגה בפעולת איבה'
    },
    'נהרגה בפעולת איבה': {
        image: terror,
        textM: 'נהרג בפעולת איבה',
        textF: 'נהרגה בפעולת איבה'
    },
    'נפל על משמרתו במחתרות': {
        image: underground,
        textM: 'נפל על משמרתו במחתרות',
        textF: 'נפלה על משמרתה במחתרות'
    },
    'חלל מערכות ישראל': {
        image: idf,
        textM: 'חלל מערכות ישראל',
        textF: 'חללת מערכות ישראל'
    },
    'נהרג על קידוש השם': {
        image: martyrs,
        textM: 'נהרג על קידוש השם',
        textF: 'נהרגה על קידוש השם'
    }
};

// פונקציה למציאת סיבת מוות מתוך המקום
const findDeathCause = (place) => {
    if (!place) return null;

    return Object.entries(DEATH_CAUSES).find(([cause]) =>
        place.includes(cause)
    )?.[0] || null;
};

// פונקציה לבדיקה האם התאריך הוא בטווח השואה
const isHolocaustPeriod = (deathDate) => {
    if (!deathDate) return false;

    try {
        // מוציא את השנה מהתאריך - לוקח את החלק האחרון אחרי ה-/
        const year = parseInt(deathDate.split('/').slice(-1)[0]);
        return !isNaN(year) && year >= 1939 && year <= 1945;
    } catch (error) {
        console.error('Error parsing death date:', error);
        return false;
    }
};

// פונקציה לבדיקת הי"ד בשם
const hasMemorialTitle = (name = '', familyName = '') => {
    const variations = [
        name,
        familyName,
        `${name} ${familyName}`
    ];

    const memorialVariations = [
        'הי"ד',
        'הי״ד',
        ' הי"ד ',
        ' הי״ד ',
        'הי"ד,',
        'הי״ד,'
    ];

    return variations.some(nameVariation =>
        memorialVariations.some(memorial =>
            nameVariation?.includes(memorial)
        )
    );
};

const MemorialIcon = ({person}) => {
    if (!person) return null;

    const isFemale = person.sex === 'F';

    // זיהוי אם זה אובייקט event מ-TodayEvents או person רגיל
    let deathPlace, deathDate;

    if (person.date) {
        // זה אובייקט event מ-TodayEvents
        deathPlace = person.date.place;
        deathDate = person.date.date;
    } else {
        // זה אובייקט person רגיל
        deathPlace = person.death?.place;
        deathDate = person.death?.date;
    }

    // בדיקת סיבת מוות מוגדרת
    const deathCauseKey = findDeathCause(deathPlace);
    const deathCause = deathCauseKey ? DEATH_CAUSES[deathCauseKey] : null;

    // אם יש סיבת מוות מוגדרת (פיגוע, צה"ל וכו')
    if (deathCause) {
        return (
            <span className="inline-block align-middle relative group">
                <img
                    crossOrigin="use-credentials"
                    src={deathCause.image}
                    alt={isFemale ? deathCause.textF : deathCause.textM}
                    className="w-11 h-11 mx-1"
                />
                <div
                    className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-sm px-2 py-1 rounded whitespace-nowrap right-1/2 transform translate-x-1/2">
                    {isFemale ? deathCause.textF : deathCause.textM}
                </div>
            </span>
        );
    }

    // מציגים סמל שואה אם:
    // 1. התאריך בטווח השואה
    // או
    // 2. אין תאריך פטירה אבל יש הי"ד בשם
    if (hasMemorialTitle(person.name, person.familyName) &&
        (isHolocaustPeriod(deathDate) || !deathDate)) {
        return (
            <span className="inline-block align-middle relative group">
                <img
                    crossOrigin="use-credentials"
                    src={holocost}
                    alt={isFemale ? 'נרצחה בשואה' : 'נרצח בשואה'}
                    className="w-11 h-11 mx-1"
                />
                <div
                    className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-sm px-2 py-1 rounded whitespace-nowrap right-1/2 transform translate-x-1/2">
                    {isFemale ? 'נרצחה בשואה' : 'נרצח בשואה'}
                </div>
            </span>
        );
    }

    return null;
};
export default MemorialIcon;